const ImageCollectionVisibility = {
	PUBLIC: "public",
	ACL_PUBLIC: "acl_public",
	ACL_PRIVATE: "acl_private",
	INTERNAL: "internal"
};
export default ImageCollectionVisibility;
